/**
 * Scroll lock global con refcounting.
 *
 * Cuando multiples modales (u otros overlays) se abren simultaneamente,
 * usamos un contador para que el ultimo en cerrar sea el que restaure el
 * overflow del body. Esto evita que cerrar un modal premature destrabe el
 * scroll cuando todavia hay otro abierto.
 *
 * Tambien preserva el estilo original de overflow para restaurarlo.
 */

let count = 0;
let originalOverflow: string | null = null;
let originalPaddingRight: string | null = null;

function getScrollbarWidth(): number {
  return window.innerWidth - document.documentElement.clientWidth;
}

export function lock(): void {
  count += 1;
  if (count === 1) {
    const body = document.body;
    originalOverflow = body.style.overflow;
    originalPaddingRight = body.style.paddingRight;

    const sbw = getScrollbarWidth();
    if (sbw > 0) {
      // Compensa el gap que deja la scrollbar para que no hay layout shift.
      const current = parseInt(getComputedStyle(body).paddingRight || '0', 10) || 0;
      body.style.paddingRight = `${current + sbw}px`;
    }
    body.style.overflow = 'hidden';
  }
}

export function unlock(): void {
  if (count === 0) return;
  count -= 1;
  if (count === 0) {
    const body = document.body;
    body.style.overflow = originalOverflow ?? '';
    body.style.paddingRight = originalPaddingRight ?? '';
    originalOverflow = null;
    originalPaddingRight = null;
  }
}

export function isLocked(): boolean {
  return count > 0;
}
